import React from 'react';
import { Reveal } from './Reveal';
type SectionHeadingProps = {
  eyebrow?: string;
  title: React.ReactNode;
  accent?: React.ReactNode;
  sub?: React.ReactNode;
  dark?: boolean;
};
export function SectionHeading({
  eyebrow,
  title,
  accent,
  sub,
  dark = false
}: SectionHeadingProps) {
  return <Reveal className="text-center" data-id="element-252" data-mp="3jznfifmga7la">
      {eyebrow && <p className={`mb-3 flex items-center justify-center gap-2.5 text-[10px] font-semibold uppercase tracking-[0.26em] ${dark ? 'text-wood' : 'text-wood-dark'}`} data-id="element-253" data-mp="3k204hcqmli7u">
          <span className={`h-px w-6 shrink-0 ${dark ? 'bg-wood' : 'bg-wood-dark'}`} aria-hidden="true" data-id="element-254" data-mp="1uk4ke9sz1cy" />
          {eyebrow}
        </p>}
      <h2 className={`font-display text-[36px] uppercase leading-[0.98] ${dark ? 'text-ivory' : 'text-ink'}`} data-id="element-255" data-mp="6slo10b552oy">
        {title}
        {accent && <span className={`block ${dark ? 'text-wood' : 'text-wood-dark'}`} data-id="element-256" data-mp="uh4vjdmd9bfz">{accent}</span>}
      </h2>
      {sub && <p className={`mt-4 font-serif text-[17px] italic leading-relaxed ${dark ? 'text-sand' : 'text-ink-body'}`} data-id="element-257" data-mp="1t9yzpvl6agk2">
          {sub}
        </p>}
    </Reveal>;
}